'use client'

import { useState, useEffect } from 'react'
import toast from 'react-hot-toast'
import apiService from '@/app/services/apiService'

export default function PersonalInfoForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const user = await apiService.getWithToken('/api/user/me/')
        setName(user.name || '')
        setEmail(user.email || '')
      } catch (error) {
        toast.error('Erro ao carregar informações do usuário.')
      }
    }

    fetchUserInfo()
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      await apiService.postWithToken('/api/user/update/', {
        name,
        current_password: currentPassword,
        new_password: newPassword,
      })

      toast.success('Informações atualizadas com sucesso!')
      setCurrentPassword('')
      setNewPassword('')
    } catch (error: any) {
      toast.error(error?.message || 'Erro ao atualizar informações.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-xl">
      <div>
        <label className="block text-sm font-medium text-gray-700">Nome</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="mt-1 w-full border rounded-md p-2 text-sm"
          placeholder={email}
        />

        {(!name || name === email) && (
          <p className="text-sm text-gray-500 mt-1">
            Seu nome ainda não foi definido. Estamos usando seu e-mail como identificação. Você pode personalizar seu nome acima.
          </p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Senha atual</label>
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className="mt-1 w-full border rounded-md p-2 text-sm"
          placeholder="Digite sua senha atual"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Nova senha</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="mt-1 w-full border rounded-md p-2 text-sm"
          placeholder="Nova senha (Atualizar?)"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition disabled:opacity-50"
      >
        {loading ? 'Salvando...' : 'Salvar alterações'}
      </button>
    </form>
  )
}
